module.exports = {"brand":"보이스캐디 스마트 골프 서비스","idPlaceholder":"아이디를 입력하세요","pwPlaceholder":"비밀번호를 입력하세요","staySignedIn":"로그인 상태 유지","login":"로그인","forgotPassword":"비밀번호를 잊으셨나요?","enterIdPw":"아이디와 비밀번호를 입력해주세요"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/lo001.json
// module id = Wzlm
// module chunks = 2